import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { TablaCalculos } from './TablaCalculos';
import servicioObjetos from '../../../servicio/ServicioObjetos';
import servicioHttp from '../../../servicio/ServicioHttp';

export const ModalCesantiaVejez = (props) => {

    const TITULO_VENTANA = "Agregar Año Cesantía Vejez Anual";

    const { verModal, cerrarVerModal, growl, refrescarTabla } = props;

    const [anio, setAnio] = useState("");
    const [errorAnio,setErrorAnio] =useState("");
    const [datosTablaCalculos,setDatosTablaCalculos] =useState([]);

    const cerrarModal = () => {
        cerrarVerModal(false);
    }

    const calcular = () => {
        if(servicioObjetos.esObjetoVacio(anio)){
            setErrorAnio("El año es requerido");
            return;
        }

        servicioHttp.consumirPostHttp("tablas/cesantiavejezpatronal/crear_solicitud.json",{anio}).then(response => {
            let listaRespuesta=response.data.lista;
            setDatosTablaCalculos(listaRespuesta);
        }).catch(error => {
            console.log("error:",error);
        });
    }

    const guardar = () => {
        growl.current.clear();
        servicioHttp.consumirPostHttp("tablas/cesantiavejezpatronal/guardar_solicitud.json",datosTablaCalculos).then(response => {
            growl.current.show({ severity: response.data.error ? 'error' : 'success', summary: response.data.error ? 'Error' : 'Exito', detail: response.data.mensaje, life: 15000 });
            if(!response.data.error){
                cerrarModal();
                refrescarTabla();
            }
        }).catch(error => {
            growl.current.show({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error en el servidor, por favor vuelva a intentar.' });
        });
    }

    const pieDialogo = () => {
        return (
            <div>
                <Button label="Guardar" icon="pi pi-check" onClick={guardar} />
                <Button label="Cancelar" icon="pi pi-times" onClick={cerrarModal} className="p-button-secondary"/>
            </div>
        );
    }

    return (
        <div>
            <Dialog header={TITULO_VENTANA} visible={verModal} 
            style={{ width: '50vw' }} modal={true} onHide={cerrarModal} footer={pieDialogo()}>
                <div className="card-w-title">
                    <div className="p-grid">
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="fechaInicial">* Ingresa Año:</label>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <InputText value={anio} onChange={(e) => setAnio(e.target.value)} />
                            {!servicioObjetos.esObjetoVacio(errorAnio) ? <div> <Message severity="error" text={errorAnio} /> </div> : null}
                        </div>

                        <div className="p-col-12 p-md-12">
                            <Button label="Calcular Valores" icon="pi-md-save" onClick={calcular} />
                        </div>
                    </div>
                </div>
                <TablaCalculos datos={datosTablaCalculos}/>
            </Dialog>
        </div>
    );
}